import { createRouter, createWebHistory } from 'vue-router'
import { encryptStorage } from "@/store";
import MainView from '../views/MainView.vue'
import ErrorView from '../views/ErrorView.vue'
import MainPage from '../pages/MainPage.vue'
import ProfilePage from '../pages/ProfilePage.vue'
import LeaderboardsPage from '@/pages/LeaderboardsPage.vue'
import StorePage from '@/pages/StorePage.vue'
import store from '@/store'
import PromotionPage from '@/pages/PromotionPage.vue'
import SignUpGuidePage from '@/pages/SignUpGuidePage.vue'
// import AboutPage from '@/pages/AboutPage.vue'
// import NewsPage from '@/pages/NewsPage.vue'
import NewsDetailsPage from '@/pages/NewsDetailsPage.vue'
import ProductDetailsPage from '@/pages/ProductDetailsPage.vue'
import RafflesPage from '@/pages/RafflesPage.vue'
import RaffleDetailsPage from '@/pages/RaffleDetailsPage.vue'
import GuessTheBalancePage from '@/pages/GuessTheBalancePage.vue'
import GuessTheBalanceDetailsPage from '@/pages/GuessTheBalanceDetailsPage.vue'
import WagerRewardsPage from '@/pages/WagerRewardsPage.vue'
import RewardsPage from '@/pages/RewardsPage.vue'

const routes = [
  {
    path: '/',
    component: MainView,
    meta: { alreadyAuth: true },
    children: [
      {
        path: '/home',
        alias: '/',
        component: MainPage
      },
      {
        path: '/leaderboards',
        alias: '/leaderboards',
        component: LeaderboardsPage
      },
      {
        path: '/store',
        alias: '/store',
        component: StorePage
      },
      {
        path: '/store/:storeType/:id',
        name: 'ProductDetailsPage',
        component: ProductDetailsPage
      },
      {
        path: '/raffle',
        alias: '/raffle',
        component: RafflesPage
      },
      {
        path: '/raffle/:id',
        alias: '/raffle/:id',
        component: RaffleDetailsPage
      },
      {
        path: '/guess-the-balance',
        alias: '/guess-the-balance',
        component: GuessTheBalancePage
      },
      {
        path: '/guess-the-balance/:id',
        alias: '/guess-the-balance/:id',
        component: GuessTheBalanceDetailsPage
      },
      {
        path: '/promotions',
        alias: '/promotions',
        component: PromotionPage
      },
      {
        path: '/rewards',
        alias: '/rewards',
        component: RewardsPage
      },
      {
        path: '/signup-guide',
        alias: '/signup-guide',
        component: SignUpGuidePage
      },
      // {
      //   path: '/about',
      //   alias: '/about',
      //   component: AboutPage
      // },
      // {
      //   path: '/news',
      //   alias: '/news',
      //   component: NewsPage
      // },
      {
        path: '/news/:id',
        alias: '/news/:id',
        component: NewsDetailsPage
      },
      {
        path: '/profile',
        alias: '/profile',
        component: ProfilePage
      },
      {
        path: '/wager-rewards',
        component: WagerRewardsPage
      },
    ]
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'ErrorView',
    component: ErrorView,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  },

})


// Global navigation guard to check auth status
router.beforeEach(async (to, from, next) => {
  await checkAuthStatus();
  next();
});

async function checkAuthStatus() {
  const baseUrl = process.env.VUE_APP_BASE_API;
  try {
    const token =
      store.state.user?.accessToken || localStorage.getItem("maherco-access-token");

    if (!token) {
      console.log("No token found, updating user to null.");
      store.commit("UPDATE_USER", null);
      store.commit("UPDATE_ISVERIFIED", false);

      encryptStorage.removeItem("vuex");
      return;
    }

    const response = await fetch(`${baseUrl}/api/auth/verifyAccessToken`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await response.json();
    console.log("Auth verification response:", data);

    if (response.ok && data.isValid) {
      console.log("Token is valid, updating Vuex store.");
      store.commit("UPDATE_ISVERIFIED", true);
      store.commit("UPDATE_USER", data.user);
    } else {
      console.log("Token is not valid, invalidating user.");
      store.commit("UPDATE_USER", null);
      store.commit("UPDATE_ISVERIFIED", false);
      localStorage.removeItem("maherco-access-token");
      encryptStorage.removeItem("vuex");
    }
  } catch (error) {
    console.error("Auth verification failed:", error);
    store.commit("UPDATE_USER", null);
    store.commit("UPDATE_ISVERIFIED", false);
    localStorage.removeItem("maherco-access-token");
    encryptStorage.removeItem("vuex");
  }
}

export default router
